module.exports = __webpack_public_path__ + "img/improve-supply-chain.853e8c71.png";